module.exports = __FOREMAN_VENDOR__LODASH__;